import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
var PublicTemplateLaunch = function (_a) {
    var children = _a.children;
    return (_jsx("div", { className: "c-app flex-row bg-launch", children: children }));
};
export default PublicTemplateLaunch;
